import React from "react";
import ImageFromFile from "./ImageFromFile";
import accounting from "accounting";
import _ from "lodash";

export default function VariantsColumns(props) {
  this.props = props;
  this.simpleAccessor = function(variant) {
    return variant;
  };
  this.renderName = function({ value }) {
    if (value.id === undefined){
      return (
        <div className="variant">
          <div className="variant-row text-left">
            <ImageFromFile image={value.images[0]} />
            <label>{value.name}</label>
          </div>
        </div>
      );
    }else{
      var arr = _.values(value.path_images);
      value.arrImages = arr;
      return (
        <div className="variant">
          <div className="variant-row text-left">
            <img src={`https://stats-staging.herokuapp.com/${value.arrImages[0]}`} alt=""/>
            <label>{value.name}</label>
          </div>
        </div>
      );
    }    
  };
  this.priceAccessor = function(variant) {
    return accounting.formatMoney(variant.price);
  };
  this.getColumns = function() {
    return [
      {
        Header: "Name",
        id: "name",
        accessor: this.simpleAccessor,
        Cell: this.renderName,
        className: "tdcell"
      },
      {
        Header: "Price",
        id: "price",
        accessor: this.priceAccessor,
        className: "tdcell"
      }
    ];
  };
}
